import { render } from "./AddAds.vue?vue&type=template&id=7bd54181"
import script from "./AddAds.vue?vue&type=script&lang=js"
export * from "./AddAds.vue?vue&type=script&lang=js"

import "./AddAds.vue?vue&type=style&index=0&id=7bd54181&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__